import { render, staticRenderFns } from "./AlarmInfo.vue?vue&type=template&id=55cd615a&scoped=true&"
import script from "./AlarmInfo.vue?vue&type=script&lang=js&"
export * from "./AlarmInfo.vue?vue&type=script&lang=js&"
import style0 from "./AlarmInfo.vue?vue&type=style&index=0&id=55cd615a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd615a",
  null
  
)

export default component.exports